import { bootstrap } from './bootstrap';

// Bootstrap the Navigator header API
if (!('ertGlobalHeader' in window)) {
  bootstrap();
}
